import { Box, TableCell, TableRow } from '@mui/material';
import type { FC, ReactElement } from 'react';

type RowDetailsProps = {
  renderChildren: () => ReactElement;
  colSpan: number;
  backgroundColor?: string;
  sticky?: boolean;
};

export const RowDetails: FC<RowDetailsProps> = ({
  renderChildren,
  colSpan,
  backgroundColor,
  sticky = false,
}) => {
  const actualColspan = (2 + colSpan) * 2 + 1; // plus edit/checkbox, plus margins that are implemented as tds
  return (
    <TableRow sx={{ backgroundColor, width: '100%' }}>
      <TableCell colSpan={actualColspan} sx={{ padding: 0 }}>
        <Box
          sx={{
            ...(sticky ? { position: 'sticky', left: 0, width: '100cqi' } : {}),
            backgroundColor,
          }}
        >
          {renderChildren()}
        </Box>
      </TableCell>
    </TableRow>
  );
};
